module.exports = __webpack_public_path__ + "static/media/YM20_1.71545510.jpg";